var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0506 8.23864C15.0506 7.87114 14.9517 7.52649 14.7798 7.22902L17.7354 3.89021C19.0327 4.46633 20.5738 3.45073 20.5505 2.02542C20.5505 0.908719 19.642 0.000197117 18.5253 0.000197117C16.9896 -0.02133 15.9865 1.72486 16.7708 3.03505L13.8152 6.3739C13.0184 6.01241 11.9743 6.2878 11.4567 6.9593L9.54877 6.24083C9.59393 5.09968 8.66706 4.13985 7.52539 4.14234C6.16944 4.11772 5.15487 5.53366 5.60436 6.8075L3.17055 8.64048C1.86139 7.71671 -0.0153788 8.69553 0.000218663 10.3098C0.000218663 11.4265 0.908741 12.335 2.02545 12.335C3.3814 12.3596 4.39597 10.9437 3.94647 9.66983L6.38029 7.83685C7.21177 8.43836 8.47546 8.2447 9.09395 7.447L11.002 8.16547C11.0153 10.8989 14.9374 10.969 15.0506 8.23864Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71102 12.4268H6.46691C6.11096 12.4268 5.82239 12.7153 5.82239 13.0713V22.0001H10.3555V13.0713C10.3555 12.7153 10.067 12.4268 9.71102 12.4268Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3554 8.28467H18.1113C17.7554 8.28467 17.4668 8.57324 17.4668 8.92919V22.0002H21.3554C21.7114 22.0002 22 21.7116 22 21.3556V8.92919C22 8.57324 21.7114 8.28467 21.3554 8.28467Z",
    fill: "#6F767E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5332 14.4976H12.2891C11.9331 14.4976 11.6445 14.7861 11.6445 15.1421V21.9998H16.1777V15.1421C16.1777 14.7861 15.8892 14.4976 15.5332 14.4976Z",
    fill: "#6F767E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88876 16.5688H0.644647C0.288697 16.5688 0.00012207 16.8574 0.00012207 17.2134V21.3555C0.00012207 21.7115 0.288697 22 0.644647 22H4.53328V17.2134C4.53328 16.8574 4.24475 16.5688 3.88876 16.5688Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit);
export default __webpack_public_path__ + "static/media/profit.5b2808055c8b4ee47c73d44160d565e2.svg";
export { ForwardRef as ReactComponent };